export function localizedFormControlValidation(element) {
  const defaultLocale = Decidim.config.config.default_locale;
  const $currentElement = $(element);
  const elementId = $currentElement.attr("id") || "";
  if (!elementId.endsWith(`_${defaultLocale}`) || $currentElement.attr("aria-invalid") === "true") {
    return;
  }
  const $form = $currentElement.closest("form");
  const $formControls = $currentElement.closest(".tabs-content").find("input,textarea");
  $formControls.each((_, element2) => $form.foundation("validateInput", $(element2)));
}
